import React, { useEffect, useRef, useState } from "react";

// import Sidebar from './SidebarScreen';

import UserIcon from "./../assets/user_icon.svg";
// import { ReactComponent as ProfileIcon } from './../assets/profile_icon.svg';
// import { ReactComponent as CalendarIcon } from './../assets/calendar_icon.svg';
// import { ReactComponent as PhoneIcon } from './../assets/profile_phone_icon.svg';
// import { ReactComponent as MailIcon } from './../assets/profile_mail_icon.svg';
import Webcam from "react-webcam";
import { CiCamera } from "react-icons/ci";
import { IoCloudUploadOutline } from "react-icons/io5";

import {
  HEADER_COLOR,
  // PRIMARY_COLOR,
  // PRIMARY_COLOR,
  SECONDARY_COLOR,
  TERTIARY_COLOR,
  // TEXT_COLOR
} from "../constants/theme";
import {
  getPatientbyID,
  updatePatient,
} from "../services/patient/patient.service";
import { toast } from "react-toastify";
import { Avatar, Button } from "@mui/material";
import Config from "../services/config";
import moment from "moment";
import Resizer from "react-image-file-resizer";
import Loader from "../components/Loader";

const ProfileScreen = () => {
  const email = sessionStorage.getItem("email");
  const patientID = sessionStorage.getItem("patientId");
  const [toggleEditProfile, setToggleEditProfile] = useState(false);

  const [loading, setLoading] = useState(false);

  const [screenWidth, setScreenWidth] = useState(0);
  const [ProfileFile, setProfileFile] = useState();
  const [userProfile, setUserProfile] = useState("");
  const [profileData, setProfileData] = useState({
    first_name: "",
    last_name: "",
    age: 0,
    dob: moment().format("YYYY-MM-DD"),
    age_group: "",
    gender: "",
    blood_group: "",
    mobile: "",
    phone: "",
    cnic: "",
    passport: "",
    whatsapp: "",
    zip_code: "",
    address: "",
    location: "",
    city: "",
    province: "",
    country: "",
    emergency_contact_name: "",
    emergency_contact_address: "",
    emergency_contact_mobile: "",
    emergency_contact_relation: "",
    shipping_address: "",
    shipping_zip_code: "",
    shipping_title: "",
    shipping_city: "",
    billing_address: "",
    billing_zip_code: "",
    billing_title: "",
    billing_city: "",
    full_name: "",
    email: "",
  });
  const [hovered, setHovered] = useState(false);

  const [webCamStatus, setWebCamStatus] = useState(false);
  const webCamRef = useRef(null);
  const inputRefUserProfile = useRef(null);

  const convertToFile = async (value) => {
    const blob = await fetch(value).then((res) => res.blob());
    const type = "image/webp";
    setProfileFile(new File([blob], "patient_profile_picture", { type }));
  };

  const getPatientData = async () => {
    try {
      setLoading(true);

      const response = await getPatientbyID(email, patientID);

      if (response.status === 200) {
        setProfileData(response?.data?.data);
        setUserProfile(
          response?.data?.data?.profile_picture
            ? typeof response?.data?.data?.profile_picture == "object"
              ? URL.createObjectURL(response?.data?.data?.profile_picture)
              : Config.filePath + response?.data?.data?.profile_picture
            : "" || ""
        );
      } else {
        toast.error("Error getting data!");
        return;
      }

      setLoading(false);
    } catch (error) {
      toast.error("ERROR FETCHING DATA!");
      console.log("ERROR FETCHING PATIENT DATA => ", error);
      setLoading(false);
      return;
    }
  };

  useEffect(() => {
    getPatientData();
  }, []);

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  const handleEditProfile = async () => {
    try {
      setLoading(true);
      const response = await updatePatient({
        ...profileData,
        email,
        profile_picture: ProfileFile ? ProfileFile : "",
      });
      if (response.status === 200) {
        toast.success("Updated");
        setToggleEditProfile(false);
        setLoading(false);
        return;
      } else {
        toast.error(response.message || response.data.message);
        setLoading(false);
        return;
      }
    } catch (error) {
      console.log("ERROR UPDATING PROFILE => ", error);
      toast.error("Internal server error!");
      setLoading(false);
      return;
    }
  };

  return (
    <div className="container-fluid p-0 position-relative">
      <div
        className="mx-auto position-relative"
        style={{
          minHeight: "100vh",
          zIndex: "100",
          padding: "2px 15px 10px 15px",
        }}
      >
        <div
          className="position-relative"
          style={{
            backgroundColor: "rgb(255, 255, 255)",
            // padding: "14px 16px 20px 16px",
            padding: "10px 10px 0px 10px",
            borderRadius: "15px",
            minHeight: "calc(100vh - 80px)",
          }}
        >
          {/* <div className="d-flex justify-content-center text-center">
            <h4
              className="text-center"
              style={{
                color: HEADER_COLOR,
              }}
            >
              Profile
            </h4>
          </div>

          <hr style={{ color: "gray" }} /> */}
          {!loading && (
            <>
              {" "}
              <div className="row w-100 mx-auto">
                {!toggleEditProfile ? (
                  <div
                    className="col-12 d-flex flex-row-reverse"
                    onClick={() => setToggleEditProfile(!toggleEditProfile)}
                  >
                    <button
                      className="btn btn-dark"
                      style={{
                        fontSize: "11px",
                        width: "auto",
                        padding: "8px 20px",
                        borderRadius: "20px",
                        fontWeight: "500",
                        letterSpacing: "0.03ch",
                      }}
                      onClick={() => setToggleEditProfile(true)}
                    >
                      Update Profile
                    </button>
                  </div>
                ) : (
                  <div
                    className="col-12 d-flex flex-row-reverse"
                    style={{
                      width: "auto",
                      padding: "17px 20px",
                      borderRadius: "20px",
                    }}
                  ></div>
                )}
              </div>
              <div className="row w-100 mx-auto">
                <div className="col-12 p-0">
                  <div className="row w-100 mx-auto align-items-center justify-content-center">
                    <div
                      className={
                        " col-xs-12 col-sm-12 col-md-3 col-lg-3 mt-4 d-flex justify-content-center"
                      }
                    >
                      <div
                        className={
                          toggleEditProfile
                            ? "border position-relative justify-content-center align-items-center text-center"
                            : "position-relative justify-content-center align-items-center text-center"
                          // +
                          // (!webCamStatus ? " mb-3" : "")
                        }
                        onMouseEnter={() => !webCamStatus && setHovered(true)}
                        onMouseLeave={() => !webCamStatus && setHovered(false)}
                        onDrop={(e) => {
                          e.preventDefault();
                          try {
                            Resizer.imageFileResizer(
                              e.dataTransfer.files[0],
                              128,
                              128,
                              "webp",
                              100,
                              0,
                              (uri) => {
                                // if (!selectedPatient) {
                                setUserProfile(uri);
                                convertToFile(uri);
                                // }
                              },
                              "base64",
                              128,
                              128
                            );
                          } catch (err) {
                            console.log(err);
                          }
                        }}
                        onDragOver={(e) => e.preventDefault()}
                        style={{
                          width: "170px",
                          cursor: toggleEditProfile ? "pointer" : "default",
                          height: "120px",
                          caretColor: "transparent",
                          background:
                            !userProfile && `url(${UserIcon}) no-repeat center`,
                        }}
                      >
                        {hovered && toggleEditProfile && (
                          <div
                            className="position-absolute"
                            style={{
                              width: "160px",
                              height: "110px",
                              top: 0,
                              backgroundColor: "rgba(256,256,256,0.4)",
                            }}
                          >
                            <CiCamera
                              // className={cx(
                              //   classes.Impressionicon,
                              //   "ion-ios-camera-outline"
                              // )}
                              className="mx-2"
                              size={30}
                              onClick={() => {
                                setWebCamStatus(true);
                                setHovered(false);
                              }}
                            />
                            <IoCloudUploadOutline
                              // className={cx(
                              //   classes.Impressionicon,
                              //   "ion-ios-cloud-upload-outline"
                              // )}
                              size={30}
                              onClick={() => {
                                setWebCamStatus(false);
                                setHovered(false);

                                inputRefUserProfile?.current?.click();
                              }}
                            />
                          </div>
                        )}
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          disabled={toggleEditProfile}
                          onChange={(event) => {
                            try {
                              Resizer.imageFileResizer(
                                event.target.files[0],
                                128,
                                128,
                                "WEBP",
                                100,
                                0,
                                (uri) => {
                                  setUserProfile(uri);
                                  convertToFile(uri);
                                },
                                "base64",
                                128,
                                128
                              );
                            } catch (err) {
                              console.log(err);
                            }
                          }}
                          ref={inputRefUserProfile}
                          style={{ display: "none" }}
                        />
                        {!webCamStatus ? (
                          <img
                            src={userProfile || ""}
                            style={{
                              width: "auto",
                              height: "auto",
                              maxWidth: "160px",
                              maxHeight: "110px",
                            }}
                          />
                        ) : (
                          <Webcam
                            audio={false}
                            ref={webCamRef}
                            style={{
                              width: "100%",
                              height: "auto",
                              maxHeight: "110px",
                              maxWidth: "160px",
                            }}
                            width="100%"
                            height="auto"
                            maxHeight="110px"
                            screenshotFormat="image/png"
                          />
                        )}
                      </div>
                      {webCamStatus && (
                        <div className="d-flex mb-3">
                          <Button
                            onClick={() => {
                              setUserProfile(
                                webCamRef.current.getScreenshot({
                                  width: 128,
                                  height: 128,
                                })
                              );
                              setHovered(false);
                              setWebCamStatus(false);
                              convertToFile(
                                webCamRef.current.getScreenshot({
                                  width: 128,
                                  height: 128,
                                })
                              );
                            }}
                          >
                            Capture
                          </Button>
                          <Button
                            onClick={() => {
                              setWebCamStatus(false);
                            }}
                          >
                            Close
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-12 p-0">
                  <div
                    className="row w-100 mx-auto flex-column flex-sm-row align-items-center justify-content-center"
                    style={{
                      gap: screenWidth >= 576 ? "10px" : "10px",
                      maxWidth: "580px",
                    }}
                  >
                    <div className="col-12 col-sm p-0">
                      <div
                        className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                        style={{
                          gap: "1px",
                          maxWidth: "180px",
                        }}
                      >
                        <div className="col-auto p-0">
                          <div
                            className="text-center"
                            style={{
                              fontSize: "10px",
                              fontWeight: "400",
                              color: SECONDARY_COLOR,
                            }}
                          >
                            First Name
                          </div>
                        </div>
                        <div className="col-12 p-0">
                          <input
                            className="text-center"
                            value={profileData.first_name}
                            disabled={!toggleEditProfile || loading}
                            onChange={(e) =>
                              setProfileData({
                                ...profileData,
                                first_name: e.target.value,
                                full_name: `${e.target.value} ${profileData?.last_name}`,
                              })
                            }
                            type="text"
                            style={{
                              // border: "none",
                              outline: "none",
                              width: "100%",
                              // maxWidth: '100%',
                              // minWidth: '180px',
                              fontSize: "10px",
                              color: HEADER_COLOR,
                              lineHeight: "1",
                              background: "none",
                              opacity: !toggleEditProfile ? ".7" : "1",
                              border: `1px solid ${TERTIARY_COLOR}`,
                              padding: "8px 7px",
                              borderRadius: "15px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm p-0">
                      <div
                        className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                        style={{
                          gap: "1px",
                          maxWidth: "180px",
                        }}
                      >
                        <div className="col-auto p-0">
                          <div
                            className="text-center"
                            style={{
                              fontSize: "10px",
                              fontWeight: "400",
                              color: SECONDARY_COLOR,
                            }}
                          >
                            Last Name
                          </div>
                        </div>
                        <div className="col-12 p-0">
                          <input
                            className="text-center"
                            type="text"
                            disabled={!toggleEditProfile || loading}
                            value={profileData.last_name}
                            onChange={(e) =>
                              setProfileData({
                                ...profileData,
                                last_name: e.target.value,
                                full_name: `${profileData?.first_name} ${e.target.value}`,
                              })
                            }
                            style={{
                              // border: "none",
                              outline: "none",
                              // maxWidth: '100%',
                              // minWidth: '180px',
                              width: "100%",
                              fontSize: "10px",
                              color: HEADER_COLOR,
                              lineHeight: "1",
                              background: "none",
                              opacity: !toggleEditProfile ? ".7" : "1",
                              border: `1px solid ${TERTIARY_COLOR}`,
                              padding: "8px 7px",
                              borderRadius: "15px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm p-0 pt-2 pt-sm-0">
                      <div
                        className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                        style={{
                          gap: "1px",
                          maxWidth: "180px",
                        }}
                      >
                        <div className="col-auto p-0">
                          <div
                            className="text-center"
                            style={{
                              fontSize: "10px",
                              fontWeight: "400",
                              color: SECONDARY_COLOR,
                            }}
                          >
                            Date of Birth
                          </div>
                        </div>
                        <div className="col-12 p-0">
                          <input
                            className="text-center"
                            type="date"
                            disabled={!toggleEditProfile || loading}
                            value={profileData.dob}
                            onChange={(e) => {
                              const d = moment(e.target.value, "YYYY-MM-DD");
                              const t = moment();
                              const a = t.diff(d, "years");
                              setProfileData({
                                ...profileData,
                                dob: e.target.value,
                                age: a,
                              });
                            }}
                            style={{
                              // border: "none",
                              outline: "none",
                              position: "relative",
                              // maxWidth: '100%',
                              // minWidth: '180px',
                              width: "100%",
                              fontSize: "10px",
                              height: "32.76px",
                              color: HEADER_COLOR,
                              lineHeight: "1",
                              background: "none",
                              opacity: !toggleEditProfile ? ".7" : "1",
                              border: `1px solid ${TERTIARY_COLOR}`,
                              // padding: '11px 7px',
                              borderRadius: "15px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 p-0">
                  <div
                    className="row w-100 mx-auto flex-column flex-sm-row align-items-center justify-content-center"
                    style={{
                      gap: screenWidth >= 576 ? "8px" : "8px",
                    }}
                  >
                    <div className="col-12 col-sm-auto p-0">
                      <div
                        className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                        style={{
                          gap: "6px",
                          minWidth: "200px",
                        }}
                      >
                        <div className="col-auto p-0">
                          <div
                            className="text-center"
                            style={{
                              fontSize: "10px",
                              fontWeight: "400",
                              color: SECONDARY_COLOR,
                            }}
                          >
                            Age Group
                          </div>
                        </div>
                        <div className="col-auto ps-3 p-0">
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              gap: "10px",
                            }}
                          >
                            <div
                              className="form-check"
                              style={{
                                fontSize: "10px",
                                paddingLeft: "0",
                                // boxShadow: 'none !important'
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="ageGroup"
                                id="teenRadioButton"
                                value="teen"
                                disabled={!toggleEditProfile || loading}
                                onChange={(e) =>
                                  setProfileData({
                                    ...profileData,
                                    age_group: e.target.value,
                                  })
                                }
                                checked={profileData.age_group === "teen"}
                                style={{
                                  boxShadow: "none",
                                  margin: "1px 5px 0 0",
                                  width: "13px",
                                  height: "13px",
                                  backgroundColor: "rgb(244, 245, 245)",
                                  borderColor: SECONDARY_COLOR,
                                }}
                              />
                              <label
                                className="form-check-label"
                                for="teenRadioButton"
                                style={{
                                  color: HEADER_COLOR,
                                  minWidth: "40px",
                                }}
                              >
                                Teen
                              </label>
                            </div>

                            <div
                              className="form-check"
                              style={{
                                fontSize: "10px",
                                paddingLeft: "0",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="ageGroup"
                                id="adultRadioButton"
                                value="adult"
                                disabled={!toggleEditProfile || loading}
                                onChange={(e) =>
                                  setProfileData({
                                    ...profileData,
                                    ageGroup: e.target.value,
                                  })
                                }
                                checked={profileData.age_group === "adult"}
                                style={{
                                  boxShadow: "none",
                                  margin: "1px 5px 0 0",
                                  width: "13px",
                                  height: "13px",
                                  backgroundColor: "rgb(244, 245, 245)",
                                  borderColor: SECONDARY_COLOR,
                                }}
                              />
                              <label
                                className="form-check-label"
                                for="adultRadioButton"
                                style={{
                                  color: HEADER_COLOR,
                                  minWidth: "40px",
                                }}
                              >
                                Adult
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-auto p-0">
                      <div
                        className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                        style={{
                          gap: "6px",
                          minWidth: "200px",
                        }}
                      >
                        <div className="col-auto p-0">
                          <div
                            className="text-center"
                            style={{
                              fontSize: "10px",
                              fontWeight: "400",
                              color: SECONDARY_COLOR,
                            }}
                          >
                            Gender
                          </div>
                        </div>
                        <div className="col-auto ps-3 p-0">
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              gap: "10px",
                            }}
                          >
                            <div
                              className="form-check"
                              style={{
                                fontSize: "10px",
                                paddingLeft: "0",
                                // boxShadow: 'none !important'
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="gender"
                                id="maleRadioButton"
                                value="male"
                                disabled={!toggleEditProfile || loading}
                                onChange={(e) =>
                                  setProfileData({
                                    ...profileData,
                                    gender: e.target.value,
                                  })
                                }
                                checked={profileData.gender === "male"}
                                style={{
                                  boxShadow: "none",
                                  margin: "1px 5px 0 0",
                                  width: "13px",
                                  height: "13px",
                                  backgroundColor: "rgb(244, 245, 245)",
                                  borderColor: SECONDARY_COLOR,
                                }}
                              />
                              <label
                                className="form-check-label"
                                for="maleRadioButton"
                                style={{
                                  color: HEADER_COLOR,
                                  minWidth: "40px",
                                }}
                              >
                                Male
                              </label>
                            </div>

                            <div
                              className="form-check"
                              style={{
                                fontSize: "10px",
                                paddingLeft: "0",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="gender"
                                id="femaleRadioButton"
                                value="female"
                                disabled={!toggleEditProfile || loading}
                                onChange={(e) =>
                                  setProfileData({
                                    ...profileData,
                                    gender: e.target.value,
                                  })
                                }
                                checked={profileData.gender === "female"}
                                style={{
                                  boxShadow: "none",
                                  margin: "1px 5px 0 0",
                                  width: "13px",
                                  height: "13px",
                                  backgroundColor: "rgb(244, 245, 245)",
                                  borderColor: SECONDARY_COLOR,
                                }}
                              />
                              <label
                                className="form-check-label"
                                for="femaleRadioButton"
                                style={{
                                  color: HEADER_COLOR,
                                  minWidth: "40px",
                                }}
                              >
                                Female
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 p-0">
                  <div
                    className="row w-100 mx-auto flex-column flex-sm-row align-items-center justify-content-center"
                    style={{
                      gap: "12px",
                    }}
                  >
                    <div className="col-12 col-sm-auto p-0">
                      <div
                        className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                        style={{
                          gap: "1px",
                          maxWidth: "180px",
                        }}
                      >
                        <div className="col-auto p-0">
                          <div
                            className="text-center"
                            style={{
                              fontSize: "10px",
                              fontWeight: "400",
                              color: SECONDARY_COLOR,
                            }}
                          >
                            Mobile
                          </div>
                        </div>
                        <div className="col-auto p-0">
                          <div
                            className="position-relative row w-100 mx-auto align-items-center justify-content-center"
                            style={{
                              border: `1px solid ${TERTIARY_COLOR}`,
                              padding: "8px",
                              borderRadius: "15px",
                            }}
                          >
                            <input
                              className="col-auto p-0 text-center"
                              value={profileData.mobile}
                              disabled={!toggleEditProfile || loading}
                              onChange={(e) =>
                                setProfileData({
                                  ...profileData,
                                  mobile: e.target.value,
                                })
                              }
                              type="text"
                              style={{
                                border: "none",
                                outline: "none",
                                maxWidth: "100%",
                                minWidth: "180px",
                                fontSize: "10px",
                                color: HEADER_COLOR,
                                lineHeight: "1",
                                background: "none",
                                opacity: !toggleEditProfile ? ".7" : "1",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-auto p-0">
                      <div
                        className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                        style={{
                          gap: "1px",
                          maxWidth: "180px",
                        }}
                      >
                        <div className="col-auto p-0">
                          <div
                            className="text-center"
                            style={{
                              fontSize: "10px",
                              fontWeight: "400",
                              color: SECONDARY_COLOR,
                            }}
                          >
                            Email
                          </div>
                        </div>
                        <div className="col-auto p-0">
                          <div
                            className="position-relative row w-100 mx-auto align-items-center justify-content-center"
                            style={{
                              border: `1px solid ${TERTIARY_COLOR}`,
                              padding: "8px",
                              borderRadius: "15px",
                            }}
                          >
                            <input
                              className="col-auto p-0 text-center"
                              type="text"
                              value={profileData.email}
                              disabled={!toggleEditProfile || loading}
                              onChange={(e) =>
                                setProfileData({
                                  ...profileData,
                                  email: e.target.value,
                                })
                              }
                              style={{
                                border: "none",
                                outline: "none",
                                maxWidth: "100%",
                                minWidth: "180px",
                                fontSize: "10px",
                                color: HEADER_COLOR,
                                lineHeight: "1",
                                background: "none",
                                opacity: !toggleEditProfile ? ".7" : "1",
                              }}
                            />

                            {/* <div className='position-absolute col-auto p-0' style={{
                                top: '0',
                                left: '0',
                                transform: 'translateX(35%) translateY(11%)',
                                width: '19px',
                                height: '19px'
                              }}>
                                <MailIcon fill={TERTIARY_COLOR} style={{
                                  width: '100%',
                                  height: '100%',
                                  overflow: 'visible'
                                }}/>
                              </div> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    {toggleEditProfile && (
                      <div className="col-12 p-0">
                        <div
                          className="row w-100 mx-auto align-items-center justify-content-center"
                          style={{
                            padding: "10px 0",
                          }}
                        >
                          <button
                            className="btn btn-dark"
                            style={{
                              fontSize: "11px",
                              width: "auto",
                              padding: "8px 20px",
                              borderRadius: "20px",
                              fontWeight: "500",
                              letterSpacing: "0.03ch",
                            }}
                            disabled={loading}
                            onClick={(e) => {
                              handleEditProfile();
                            }}
                          >
                            Save Profile
                          </button>
                        </div>
                        {loading && <Loader />}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}

          {loading && <Loader />}
        </div>
      </div>
    </div>
  );
};

export default ProfileScreen;
